import type { ISprite, SpriteOptions } from '../IRenderer';

/**
 * createSprite — substrate-agnostic factory for textured sprite surfaces.
 *
 * Phase H10 Arc λ.10 (2026-05-10): PhaserSprite fallback removed.
 * PixiFactoriesRegistry wires the Pixi impl at boot; createSprite
 * always returns a PixiSprite. The `_scene` parameter is retained for
 * call-site compatibility (pre-λ.10b sweep); λ.10b drops it entirely.
 */

type PixiFactory = (opts: SpriteOptions) => ISprite;

let pixiFactory: PixiFactory | null = null;

export function registerPixiSpriteFactory(fn: PixiFactory): void {
  pixiFactory = fn;
}

export function createSprite(_scene: unknown, opts: SpriteOptions): ISprite {
  if (!pixiFactory) {
    throw new Error('[createSprite] Pixi factory not registered. Call registerAllPixiFactories() at boot.');
  }
  return pixiFactory(opts);
}
